import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, forkJoin, empty } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { CompanyContactService, LLFormService, StorageManagerService } from '../../shared/services/index';



@Injectable()
export class BusinessCategoryResolverService implements Resolve<any> {
  customerGuid: string;

  constructor ( private storageManagerService: StorageManagerService,
    private companyService: CompanyContactService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {

    const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');

    if (currentCustomerStr) {
        const currentCustomer = JSON.parse(currentCustomerStr);
        if (currentCustomer) {
        this.customerGuid = currentCustomer.customerGuid;
        }
    }

    const retVal = forkJoin([
      this.companyService.getBusinessCategories(true)]
        )
        .pipe(catchError(err => of(err)));

        return retVal;
    }
}
